export var OfficeType;
(function (OfficeType) {
    OfficeType["DOCX"] = "Document";
    OfficeType["PPTX"] = "Powerpoint";
    OfficeType["XLSX"] = "Spreadsheet";
})(OfficeType || (OfficeType = {}));
